import { useEffect, useRef } from 'react'

import { useFilePreview } from '../../File'
import { ICON_HEIGHT_40, IconSpinner } from '../../Icon'

import { VIDEO_SIGNATURE_TIMEOUT_SECS } from './VideoPreview.constants'
import { isVideoPlaying } from './VideoPreview.utils'

import * as styles from './VideoPreview.module.css'

function VideoPreview({
  className = styles.VideoPreview,
  file: video,
  getFileById,
  scope,
  subject,
}) {
  const videoRef = useRef(null)

  const { file, loading, setSignExpired } = useFilePreview({
    apiParams: { object_id: subject, scope },
    file: video,
    getFileById,
  })

  useEffect(() => {
    if (videoRef?.current) {
      setSignExpired(false)
      const time = videoRef.current.currentTime
      const playing = isVideoPlaying(videoRef.current)

      videoRef.current.load()

      if (playing) {
        videoRef.current.currentTime = time
        videoRef.current.play()
      }

      setTimeout(
        () => setSignExpired(true),
        VIDEO_SIGNATURE_TIMEOUT_SECS * 1000
      )
    }
  }, [file])

  return !file || loading ? (
    <IconSpinner size={ICON_HEIGHT_40} />
  ) : (
    /* eslint-disable-next-line jsx-a11y/media-has-caption -- user-uploaded media has no caption track */
    <video controls className={className} ref={videoRef}>
      <source src={file?.origin} type={file?.mime_type} />
    </video>
  )
}

export default VideoPreview
